{
	"label": "Catégories",
	"addAll": "Tout ajouter",
	"removeAll": "Tout supprimer"
}
